module.exports = __webpack_public_path__ + "img/day-snow.c643bf63.svg";